export * from './enums';
// Provided by Webpack.
export const APP_VERSION = window.APP_SETTINGS.appVersion;
export const ADYEN_CLIENT_KEY = window.APP_SETTINGS.adyenClientKey;
export const ADYEN_ENVIRONMENT = window.APP_SETTINGS.adyenEnvironment === 'live' ? 'live' : 'test';

// Feature flags
export const ENABLE_NEW_TV_GUIDE = true;
export const ENABLE_ADVERTISEMENTS = true;
